import { ABU } from "@client/config";
import { css } from "@emotion/css";
import React from "react";

export function KnowledgeFile({ fileName }: { fileName: string }) {
  return (
    <iframe
      src={`${ABU}/knowledgePoint/${fileName}#toolbar=0`}
      width="100%"
      height="100%"
      className={css`
        border: none;
        padding: -1rem;
      `}
    />
  );
}
